/** The install command shown on the Site install view. */
export const sdkInstallCommand = "npm install @plannotator/appnotes";

/** The connected-mode configuration shown on the Site install view. */
export function sdkConfiguration(siteId: string, apiOrigin: string): string {
  return `import { createAppNotes } from "@plannotator/appnotes";

const appNotes = createAppNotes({
  mode: "connected",
  siteId: ${JSON.stringify(siteId)},
  apiOrigin: ${JSON.stringify(apiOrigin)},
  theme: "auto",
});

await appNotes.mount();`;
}
